import { apiRawGet, apiRawPost } from "./client";

export function getReport(
  scenarioId: number,
  routeName: string,
): Promise<Response> {
  return apiRawGet(`/model/export/${scenarioId}/${routeName}`);
}

export function getOperationalReport(
  scenarioId: number,
  routeName: string,
  periods: string,
): Promise<Response> {
  return apiRawGet(`/model/export/${scenarioId}/${routeName}/${periods}`);
}

export function submitWorksheetJob(
  scenarioId: number,
  sensitivityId?: number,
): Promise<Response> {
  const body: Record<string, number> = { scenario_id: scenarioId };
  if (sensitivityId) body.sensitivity_id = sensitivityId;
  return apiRawPost("/worksheet/generate-and-validate", body);
}

export async function pollWorksheetJob(
  jobId: string,
  onProgress?: (progress: number, total: number, stepLabel: string) => void,
): Promise<any> {
  const MAX_ATTEMPTS = 180;
  const INTERVAL_MS = 2000;

  for (let i = 0; i < MAX_ATTEMPTS; i++) {
    const response = await apiRawGet(`/worksheet/job/${jobId}`);
    if (!response.ok) {
      if (response.status === 500) {
        const err = await response.json();
        throw new Error(err.detail || "Job failed");
      }
      return null;
    }

    const data = await response.json();
    if (data.status === "pending") {
      if (onProgress && data.progress != null && data.total != null) {
        onProgress(data.progress, data.total, data.step_label || "");
      }
      await new Promise((resolve) => setTimeout(resolve, INTERVAL_MS));
      continue;
    }

    return data;
  }
  throw new Error("Worksheet generation timed out");
}

export function downloadWorksheetJobFile(jobId: string): Promise<Response> {
  return apiRawGet(`/worksheet/job/${jobId}/download`);
}

export function downloadExcelValuesOnly(
  scenarioId: number,
): Promise<Response> {
  return apiRawGet(`/worksheet/${scenarioId}/download`);
}

export function downloadExcelSensitivityValuesOnly(
  scenarioId: number,
  sensitivityId: number,
): Promise<Response> {
  return apiRawGet(
    `/worksheet/${scenarioId}/sensitivity/${sensitivityId}/download`,
  );
}
